// Singleton de IndexedDB para Dashboard JMA AFAC.
//
// Centraliza la apertura de la base de datos para que los distintos
// módulos (validation-queue, inventory-store, futuros) compartan
// versión y schema sin colisiones de upgrade.
//
// Schema actual (DB_VERSION = 2):
//   - validation-queue (keyPath: 'id', autoIncrement): cambios pendientes
//     de subir a SharePoint cuando hay fallo de red.
//   - inventory-cache (sin keyPath): snapshot persistente del inventario
//     enriquecido para render instantáneo entre sesiones.

import { openDB } from 'idb'

const DB_NAME = 'jma-afac-dashboard'
const DB_VERSION = 2

export const STORE_VALIDATION_QUEUE = 'validation-queue'
export const STORE_INVENTORY_CACHE = 'inventory-cache'

let dbPromise = null

export function getDb() {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE_VALIDATION_QUEUE)) {
          db.createObjectStore(STORE_VALIDATION_QUEUE, {
            keyPath: 'id',
            autoIncrement: true
          })
        }
        if (!db.objectStoreNames.contains(STORE_INVENTORY_CACHE)) {
          db.createObjectStore(STORE_INVENTORY_CACHE)
        }
      },
      blocked() {
        // eslint-disable-next-line no-console
        console.warn(
          '[db] Otra pestaña tiene una versión anterior abierta. Cerrá las pestañas duplicadas para completar el upgrade.'
        )
      },
      terminated() {
        // eslint-disable-next-line no-console
        console.warn('[db] Conexión IndexedDB cerrada inesperadamente.')
        dbPromise = null
      }
    })
  }
  return dbPromise
}
